import {SIDE_NAV_LIGHT, NAV_TYPE_SIDE, DIR_LTR} from 'constants/ThemeConstant';
import {env} from './EnvironmentConfig'

export const isDev = process.env.NODE_ENV === 'development'
export const APP_NAME = 'Bplanner - Система управления';
export const API_BASE_URL = env.API_ENDPOINT_URL
export const APP_PREFIX_PATH = '/app';
export const AUTH_PREFIX_PATH = '/auth';
export const AVATARS_BASE_URL = 'https://s3.twcstorage.ru/bplanner-main-avatars';
// export const API_GATEWAY = 'https://api.bplanner.online';
// export const API_TOPCATALOG = 'https://topcatalog.dev.redramka.ru'
export const API_TOPCATALOG = 'https://topcatalog.ru'
export const API_GATEWAY = isDev
  ? 'https://api.bplanner.ru'
  // ? 'https://bplanner-back.dev.redramka.ru'
  // ? 'https://bplanner-back-2.dev.redramka.ru'
  // ? 'http://localhost:8000'
  // : 'https://bplanner-back.dev.redramka.ru'
  // : 'https://bplanner-back-2.dev.redramka.ru'
  : 'https://api.bplanner.ru'
  // : 'http://localhost:8000'

export const THEME_CONFIG = {
  navCollapsed: false,
  sideNavTheme: SIDE_NAV_LIGHT,
  locale: 'en',
  navType: NAV_TYPE_SIDE,
  topNavColor: '#3e82f7',
  headerNavColor: '',
  mobileNav: false,
  currentTheme: 'light',
  direction: DIR_LTR
};